import { render, staticRenderFns } from "./VirtualTour.vue?vue&type=template&id=770c8952&scoped=true"
import script from "./VirtualTour.vue?vue&type=script&lang=js"
export * from "./VirtualTour.vue?vue&type=script&lang=js"
import style0 from "./VirtualTour.vue?vue&type=style&index=0&id=770c8952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770c8952",
  null
  
)

export default component.exports